import {useEffect} from 'react';

import {useNavigate, useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useUser} from '../hooks/useUser';
import {useUsersSelection} from '../hooks/useUsersSelection';
import {useEditPageTools} from '../hooks/useEditPageTools';

export const EditPage = () => {

    const navigate = useNavigate();

    const {id: userId} = useParams();

    if (typeof userId === 'undefined') {
        throw new Error('userId is required parameter');
    }

    const {
        record: user,
        updateRecord,
    } = useUser(userId);

    const {handleClearSelection} = useUsersSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    if (!user) {
        return <PlatformLoader message='Loading user...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={user.name ? user.name : user.id}
            pageNavigation={<EditPageNavigation component={user}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={user}
                    />
                </Stack>
                :
                <RecordForm
                    record={user}
                    handleSubmit={updateRecord}
                    handleCancel={() => navigate('/users')}
                />}


        </FormPageLayout>
    );
};
